import axios from "axios"
import { useState } from "react"
import { Button, FormControl, Modal } from "react-bootstrap"
import AxiosConfig from "src/utilities/AxiosConfig"
import snackBar from "src/utilities/snackBar/SnackBar"

type Props = {
	vehicleInformationId: number
	currentUnitNumber: string | null
	onSuccess: () => void
}

export default function RenameUnitNumberButton({
	vehicleInformationId,
	currentUnitNumber,
	onSuccess,
}: Props) {
	const [show, setShow] = useState(false)
	const [unitNumber, setUnitNumber] = useState("")

	const open = () => {
		setUnitNumber(currentUnitNumber || "")
		setShow(true)
	}

	const close = () => setShow(false)

	const submit = () => {
		const trimmed = unitNumber.trim()
		if (!trimmed) return

		axios
			.put(
				`${process.env.REACT_APP_API_URL}/api/fleet/vehicles/${vehicleInformationId}/unit-number`,
				JSON.stringify(trimmed),
				{
					headers: {
						...AxiosConfig.configValue("min").headers,
						"Content-Type": "application/json",
					},
				},
			)
			.then(() => {
				snackBar({ type: "success", text: "Unit number updated", timeout: 3000 })
				close()
				onSuccess()
			})
			.catch((err) => {
				snackBar({
					type: "error",
					text: err.response?.data?.Message || "Failed to rename unit number",
					timeout: 4000,
				})
			})
	}

	return (
		<>
			<i
				className="material-icons action-text unit-number-rename-icon"
				role="button"
				title="Rename unit number"
				onClick={open}
			>
				edit
			</i>
			<Modal show={show} onHide={close}>
				<Modal.Header closeButton>
					<Modal.Title>Rename Unit Number</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormControl
						type="text"
						placeholder="New unit number"
						value={unitNumber}
						onChange={(e) => setUnitNumber(e.target.value)}
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={close}>
						Cancel
					</Button>
					<Button
						variant="primary"
						disabled={!unitNumber.trim()}
						onClick={submit}
					>
						Confirm
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}
